'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.curry');

var _lodash2 = _interopRequireDefault(_lodash);

var _fromTime = require('./fromTime');

var _fromTime2 = _interopRequireDefault(_fromTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//@flow
var steps = {
  milliseconds: 1,
  seconds: 1000,
  minutes: 60 * 1000,
  hours: 60 * 60 * 1000,
  days: 24 * 60 * 60 * 1000,
  weeks: 7 * 24 * 60 * 60 * 1000
};

var _addMonth = function _addMonth(count, date) {
  var clone = new Date(date);

  clone.setMonth(date.getUTCMonth() + count);
  if (clone.getUTCMonth() !== (date.getUTCMonth() + count) % 12) {
    return new Date('invalid');
  }
  return clone;
};

var _addYear = function _addYear(count, date) {
  var clone = new Date(date);

  clone.setUTCFullYear(date.getUTCFullYear() + count);
  return clone;
};

exports.default = (0, _lodash2.default)(function (step, count, date) {
  switch (step) {
    case 'months':
      return _addMonth(count, date);
    case 'years':
      return _addYear(count, date);
    default:
      if (steps[step] === void 0) {
        return new Date('invalid');
      }
      return (0, _fromTime2.default)(steps[step] * count + date.getTime());
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fp/build/add.js
// module id = 1382
// module chunks = 0 1 2 3 4 5 7 8 9